function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M16.429 7.898c-.008-.022-.013-.046-.022-.067a.779.779 0 00-.169-.266l-1.964-2.034a.737.737 0 00-1.068 0 .826.826 0 000 1.125l.713.758H7.241c-.406 0-.736.368-.736.788 0 .421.33.79.736.79h6.777l-.775.754a.77.77 0 000 1.08.737.737 0 001.067-.012l1.966-2.04a.81.81 0 00.153-.876zm-6.684 2.474c-.406 0-.666.342-.666.762v2.02c0 .477-.31.966-.771.966H2.984c-.46 0-.955-.489-.955-.966V3.578c0-.477.495-.698.955-.698h5.324c.46 0 .77.221.77.698v2.02c0 .42.261.762.667.762.407 0 .667-.341.667-.762v-2.02c0-1.316-.832-2.275-2.104-2.275H2.984c-1.272 0-2.479.959-2.479 2.275v9.577c0 1.315 1.207 2.542 2.479 2.542h5.324c1.272 0 2.104-1.227 2.104-2.543v-2.02c0-.42-.26-.762-.667-.762z",
  id: "ExternalLink_svg__a",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#ExternalLink_svg__a"
});

var SvgExternalLink = function SvgExternalLink(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 17",
    focusable: false
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/ExternalLink.7480dd08.svg";
export { SvgExternalLink as ReactComponent };